var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 0.094,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    width: 12,
    height: 2,
    rx: 0.389,
    fill: "#DDD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 24.252,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24.195,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 6,
    width: 12,
    height: 2,
    rx: 0.389,
    fill: "#DDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 6.289,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 30.447,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 18.059,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21.098,
    width: 13.539,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 3,
    width: 17,
    height: 2,
    rx: 0.389,
    fill: "#DDD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 27.352,
    width: 13.539,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 17,
    width: 13.539,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 9,
    width: 12,
    height: 2,
    rx: 0.389,
    fill: "#DDD"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 3.189,
    width: 13.539,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 27.352,
    width: 11.077,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 33.545,
    width: 54.577,
    height: 2.224,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.711,
    y: 75,
    width: 54.577,
    height: 2.224,
    rx: 0.389,
    fill: "#B3B3B3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 23,
    height: 4,
    rx: 0.389,
    fill: "#DDD"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 37.262,
    width: 8.615,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 37.262,
    width: 3.077,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 16.922,
    y: 37.262,
    width: 3.692,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 22.461,
    y: 37.262,
    width: 3.077,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 37.262,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37.262,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 37.262,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0.922,
    y: 65.695,
    width: 8.615,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 65.695,
    width: 3.077,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 16.922,
    y: 65.695,
    width: 3.692,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 22.461,
    y: 65.695,
    width: 3.077,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 65.695,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 65.695,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 65.695,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 68.793,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 40.922,
    y: 71.891,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 68.793,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 71.891,
    width: 9.846,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 68.793,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 49.537,
    y: 71.891,
    width: 5.538,
    height: 1.858,
    rx: 0.389,
    fill: "#DDD"
  })));
};

export default Svg1;